import { render, staticRenderFns } from "./Passengers.vue?vue&type=template&id=1a892d1d&scoped=true&"
import script from "./Passengers.vue?vue&type=script&lang=js&"
export * from "./Passengers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a892d1d",
  null
  
)

export default component.exports